
import { GrMail } from "react-icons/gr";
import { MdArrowForward, MdCall } from "react-icons/md";
import { BsInstagram } from "react-icons/bs";
import { TbSmartHome } from "react-icons/tb";
import { BiUser } from "react-icons/bi";
import { RiServiceLine, RiProjectorLine } from "react-icons/ri";
import { MdOutlinePermContactCalendar } from "react-icons/md";
import { HiCode } from "react-icons/hi";
import { SiTensorflow } from "react-icons/si";
import { FaPython } from "react-icons/fa";
import { GrLinkedin } from "react-icons/gr";
import { BsGithub } from "react-icons/bs";
import { BsFacebook } from "react-icons/bs";
import { SiLeetcode } from "react-icons/si";
import { GoProject } from "react-icons/go";
import { MdWorkOutline } from "react-icons/md";
import { HiChartSquareBar } from "react-icons/hi";

import AZ900 from "../assets/badges/AZ900.png";
import AI900 from "../assets/badges/AI900.png";
import AWS from "../assets/badges/aws.png";
import DP900 from "../assets/badges/DP900.png";
import PDS from "../assets/badges/PDS.png";
import IPT from "../assets/badges/IPT.png";

import VIT from "../assets/logos/vit.png";
import RLR from "../assets/logos/rlr.jpg";
import MIC from "../assets/logos/mic.jpg";
import DSC from "../assets/logos/dsc.jpg";
import Samsung from "../assets/logos/samsung.jpg";
import Oracle from "../assets/logos/oracle.png";

import AI from "../assets/dev/ai.png";
import Data from "../assets/dev/dataa.png";
import Web from "../assets/dev/web.png";

import SME from "../assets/Projects/sme.jpg";
import Memories from "../assets/Projects/memories.jpg";
import Phishing from "../assets/Projects/phishing.jpg";
import MentalHealth from "../assets/Projects/mentalHealth.jpg";
import Recipe from "../assets/Projects/recipe.jpg";
import Library from "../assets/Projects/library.jpg";
import Agro from "../assets/Projects/agro.png";
import SupplySync from "../assets/Projects/supplysync.png";
import SmartOps from "../assets/Projects/smartops.jpeg";
import Pinecone from "../assets/Projects/pinecone.png";
import Grammar from "../assets/Projects/grammar.jpg";

export const content = {
  nav: [
    {
      link: "#home",
      icon: TbSmartHome,
    },
    {
      link: "#about",
      icon: BiUser,
    },
    {
      link: "#experience",
      icon: MdWorkOutline,
    },
    {
      link: "#projects",
      icon: HiChartSquareBar,
    },
    {
      link: "#contact",
      icon: MdOutlinePermContactCalendar,
    },

  ],
  hero: {
    title: "Web Developer",
    firstName: "Santhosh",
    LastName: "Raminedi",
    btnArray: [
  "Software Engineer",
  "Backend & Cloud Engineer",
  "AI Agents • Microservices • GenAI"
]
,
    image: "https://santhosh-raminedi.netlify.app/assets/person.5ec72742.png",
    hero_content: [
      {
        text: "santhosh.raminedi22@gmail.com",
        icon: GrMail,
        link: "mailto:santhosh.raminedi22@gmail.com",
      },
      {
        text: "raminedisanthosh22",
        icon: GrLinkedin,
        link: "https://www.linkedin.com/in/raminedisanthosh22/"
      },
      {
        text: "Santhosh2231",
        icon: BsGithub,
        link: "https://github.com/Santhosh2231",
      },
      {
        text: "Santhosh Raminedi",
        icon: SiLeetcode,
        link: "https://leetcode.com/u/santhoshraminedi22/",
      }
    ],
  },
  education: [
    {
      title: "Vellore Institute Of Technology",
      course: "B.Tech in Computer Science",
      time: "2020 - 2024",
      text: "Current CGPA : 9.07",
      logo: VIT
    },
    {
      title: "Dr. R L R junior college",
      course: "Class 11th and 12th",
      time: "2018-2020",
      text: "Marks: 979/1000",
      logo: RLR
    }
  ],
  services: [
    {
      title: "Frontend & Programming Languages",
      icon: Web,
      tools: [
        "Java",
        "Python",
        "JavaScript",
        "TypeScript",
        "SQL",
        "Bash",
        "HTML",
        "CSS",
        "React JS",
        "Git"
      ],
    },
    {
      title: "Backend, Cloud & DevOps",
      icon: Web,
      tools: [
        "Spring Boot",
        "Flask",
        "REST APIs",
        "Kafka",
        "Microservices",
        "Event-driven Architecture",
        "Docker",
        "Kubernetes",
        "AWS",
        "Oracle Cloud Infrastructure (OCI)",
        "GitLab CI/CD",
        "Oracle Database",
        "PostgreSQL",
        "MySQL",
        "Linux"
      ],
    },
    {
      title: "AI, ML & Generative AI",
      icon: AI,
      tools: [
        "pytorch",
        "TensorFlow",
        "Scikit-learn",
        "NumPy",
        "Pandas",
        "Machine Learning",
        "NLP",
        "GenAI",
        "AI Agents",
        "Wayflow",
        "LangChain",
        "Model Inference Pipelines",
        "Data Preprocessing"
      ],
    }
  ]
  ,
  projects: [
    {
      id: "agentir",
      title: "Agent IR - SmartOps Analyzer (Wayflow Hackathon Project)",
      image: SmartOps,

      overview:
        "Agent IR is an agentic AI system developed during the Agent IR Hackathon (7th place) to improve developer productivity and operational reliability through AI-assisted automation.",

      built: [
        "Contributed to the SmartOps Analyzer and Knowledge Agent, using an agent-based architecture.",
        "Designed backend workflows to orchestrate multiple AI agents for code review assistance, CI/CD pipeline failure analysis, Kubernetes monitoring and log analysis, and knowledge retrieval from documentation and past incidents.",
        "Implemented agent orchestration logic using Wayflow to route tasks dynamically based on context."
      ],

      why:
        "This project demonstrates hands-on experience with Agentic AI systems, backend orchestration, and AI-driven DevOps automation—going beyond traditional ML projects.",

      tech: [
        "Python",
        "Wayflow",
        
        "Agentic AI",
        "AI Orchestration",
        "Backend APIs",
        "CI/CD",
        "Kubernetes"
      ],

      github: ""
    },

    {
      id: "agrovision",
      title: "AgroVision – AI-Driven Farming Decision Platform",
      image: Agro,

      overview:
        "AgroVision is an AI-driven decision support platform designed to help farmers make data-informed agricultural choices. The system integrates machine learning models with backend services to provide crop recommendations, disease detection, and price analytics.",

      built: [
        "Designed RESTful backend APIs to serve AI-driven insights for crop selection and disease prediction.",
        "Integrated ML and deep learning inference pipelines into backend services for real-time predictions.",
        "Implemented data preprocessing and analytics workflows to ensure accurate and reliable outputs."
      ],

      why:
        "Demonstrates the ability to combine backend engineering with ML systems, focusing on scalability, clean APIs, and real-world decision-making workflows.",

      tech: [
        "Python",
        "Flask",
        "REST APIs",
        "Machine Learning",
        "Deep Learning",
        "Data Analytics"
      ],

      github: "https://github.com/your-repo/agrovision"
    },

    {
      id: "supplysunc",
      title: "SupplySync – Smart Inventory & Logistics Manager",
      image: SupplySync,

      overview:
        "SupplySync is a cloud-native inventory and logistics management system built to handle real-time inventory updates and order processing for businesses at scale.",

      built: [
        "Designed and implemented backend microservices using an event-driven architecture.",
        "Used Kafka to enable asynchronous processing of inventory updates and order events, ensuring scalability and eventual consistency.",
        "Deployed services on AWS (EC2, ALB, VPC) with secure networking and operational monitoring dashboards."
      ],

      why:
        "This project showcases production-style backend engineering, distributed systems design, and real-time data processing—closely aligned with industry backend roles.",

      tech: [
        "Java",
        "Spring Boot",
        "Kafka",
        "AWS (EC2, ALB, VPC)",
        "REST APIs",
        "Event-Driven Architecture"
      ],

      github: "https://github.com/your-repo/supplysunc"
    },

    {
      id: "imagesearch",
      title: "Image Similarity Search using Vector Index (Pinecone)",
      image: Pinecone,

      overview:
        "A backend system for performing large-scale image similarity search using vector embeddings and cosine similarity, optimized for fast and accurate retrieval.",

      built: [
        "Implemented backend APIs to extract image embeddings using deep learning models.",
        "Stored and indexed embeddings in Pinecone, enabling low-latency similarity queries.",
        "Designed efficient retrieval workflows focusing on accuracy, performance, and scalability."
      ],

      why:
        "Demonstrates understanding of modern AI infrastructure, vector databases, and backend services that power AI-driven search systems.",

      tech: [
        "Python",
        "Flask",
        "Pinecone",
        "Vector Search",
        "Deep Learning",
        "REST APIs"
      ],

      github: "https://github.com/your-repo/vector-search"
    },

    {
      id: "phishing",
      title: "Phishing Website Detection",
      image: Phishing,

      overview:
        "A backend-driven classification system that detects phishing websites by analyzing URL-based features and applying machine learning models.",

      built: [
        "Engineered features from URLs using rule-based and ML-driven techniques.",
        "Trained and evaluated classification models for phishing detection.",
        "Exposed prediction services through backend APIs for real-time inference."
      ],

      why:
        "Highlights applied machine learning combined with backend API design and real-time classification workflows.",

      tech: [
        "Python",
        "Flask",
        "Machine Learning",
        "Feature Engineering",
        "REST APIs"
      ],

      github: "https://github.com/your-repo/phishing-detection"
    },

    
  ],
  experiences: [
    {
      title: "Associate Application Developer",
      company_name: "Oracle Financial Services Software",
      icon: Oracle,
      iconBg: "#383E56",
      date: "July 2024 - Present",
      points: [
        "Built and maintained the Migration Service for on-prem to cloud migration, handling connectors and Process Modeling Framework (PMF) to orchestrate automated financial workflows with controlled execution.",
        "Developed and operated backend microservices for the Application Data Service (ADS), including schema management and backend service logic using Java and Kubernetes.",
        "Developed Java utilities for connector extraction and metadata processing, reducing execution time by ~90% and enabling smooth catalog upgrades across releases.",
        "Integrated Oracle Data Intelligence Services and Oracle Analytics Server (OAS) into distributed applications using automated Linux scripting pipelines.",
        "Handled CI/CD pipelines, Docker image builds, Kubernetes deployments, password rotation pipelines, and tenant provisioning and upgrades in Oracle Cloud Infrastructure (OCI)."
      ]
    },
    {
      title: "PRISM Research Intern",
      company_name: "Samsung",
      icon: Samsung,
      iconBg: "#383E56",
      date: "December 2022 - August 2023",
      points: [
        "Built an end-to-end data pipeline for a UWB-based static gesture detection system, handling raw sensor ingestion, noise reduction, normalization, and outlier removal for real-time inference.",
        "Designed and evaluated multiple deep learning models for gesture classification using UWB sensor data.",
        "Achieved model accuracy greater than 95% while meeting real-time constraints of ~1 second latency and low memory usage.",
        "Delivered a complete real-time application from sensor input to visualized gesture output."
      ]
    }
  ],
  badges: [
    {
      title: "AWS Certified Solutions Architect – Associate",
      badge: AWS,
      link: "https://www.credly.com/badges/513c2589-b5e6-48dc-9358-7dfd0b51cd00/public_url"
    },
    {
      title: "Azure Fundamentals",
      badge: AZ900,
      link: "https://www.credly.com/badges/fded486b-4192-4178-a199-27b785e1c189/public_url"
    },
    {
      title: "Azure AI Fundamentals",
      badge: AI900,
      link: "https://www.credly.com/badges/7e48885d-031d-4e2f-9735-fe803aec556d/public_url"
    }
  ]

}